export { MinusCircle as default } from './MinusCircle';
